<template>
  <div
    :style="{
      '--custom-xsou-height': `${logoList[0]?.remark || 62}px`,
    }"
  >
    <header class="header">
      <div class="nav-container">
        <div class="logo" v-if="logoList.length > 0">
          <img :src="logoList[0].image" :alt="logoList[0].title" />
        </div>
        <div class="nav-links">
          <a
            :href="item.path"
            class="nav-link"
            v-for="(item, index) in navList"
            :key="index"
          >
            {{ item.text }}</a
          >
        </div>
        <div class="auth-links">
          <div v-if="userInfo.token">
            <span>{{ userInfo.nick_name }}</span>
            <!-- 退出 -->
            <a @click="logout" class="clickable">{{ $t('common.logout') }}</a>
          </div>
          <div v-else>
            <!-- 登录 -->
            <a @click="openLoginDialog" class="clickable">{{
              $t('common.login')
            }}</a>
            <!-- 注册 -->
            <a @click="openLoginDialog" class="clickable">{{
              $t('common.register')
            }}</a>
          </div>
        </div>
      </div>
    </header>

    <section class="banner">
      <div class="banner-content">
        <div class="banner-logo">
          <img :src="require('@/assets/pc/pc-blogo.png')" alt="bg" />
        </div>
        <div class="search-container">
          <!-- 搜索料号、名称 -->
          <input
            type="text"
            id="keyword"
            class="search-input"
            :placeholder="$t('common.searchPlaceholder')"
            v-model.trim="searchKeyword"
            @keyup.enter="onProductSearch"
          />
          <!-- 先搜一下 -->
          <button class="search-button" type="button" @click="onProductSearch">
            {{ $t('common.searchAction') }}
          </button>
        </div>
      </div>
    </section>

    <div style="width: 1480px; margin: 0 auto; padding: 40px 0">
      <div class="news-section">
        <!-- 先搜服务 -->
        <div class="news-title">{{ $t('pcFooter.services') }}</div>
        <div class="news-grid">
          <a
            :href="item.url"
            v-for="(item, index) in bannerNavList"
            :key="index"
          >
            <div class="news-item">
              <div class="news-image">
                <img :src="item.image" :alt="item.title" />
              </div>
              <div class="news-heading">{{ item.title }}</div>
              <div class="news-desc">{{ item.remark }}</div>
            </div>
          </a>
        </div>
      </div>
    </div>

    <pcFooter />

    <!-- Element UI 弹窗 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="800px"
      :before-close="handleClose"
      custom-class="login-dialog"
    >
      <div class="dialog-content">
        <!-- 左侧内容 -->
        <!-- 左侧底部图片（可替换实际路径） -->
        <div class="left-poster">
          <!-- 海报 -->
          <img
            :src="require('@/assets/bg/home-bg.png')"
            :alt="$t('devUpdates.poster')"
          />
        </div>
        <!-- 右侧内容 -->
        <div class="right-panel">
          <!-- 顶部标签 -->
          <el-tabs v-model="activeTab" @tab-click="handleClick" stretch>
            <!-- 微信登录 -->
            <el-tab-pane :label="$t('auth.wechatLogin')" name="wechat">
            </el-tab-pane>
            <!-- 免密登录 -->
            <el-tab-pane
              :label="$t('devUpdates.passwordlessLogin')"
              name="sms"
            ></el-tab-pane>
          </el-tabs>

          <!-- 内容区域 -->
          <div class="tab-content">
            <!-- 微信登录 -->
            <div v-if="activeTab === 'wechat'" class="wechat-login">
              <div v-if="!isInvalid">
                <div v-if="!userInfo.token">
                  <!-- 微信二维码 -->
                  <van-image
                    :src="wxLoginUrl"
                    :alt="$t('devUpdates.wechatQrCode')"
                    class="qrcode"
                  />
                  <!-- 打开微信扫一扫，快速登录/注册 -->
                  <p>{{ $t('devUpdates.scanWithWechatToLogInOrSignUp') }}</p>
                </div>
                <!-- 绑定手机号 -->
                <!-- <div v-else>
                  <div>
                    <i class="el-icon-arrow-left"></i>
                    返回扫码
                  </div>
                  <div class="form">
                    <div class="form-item">
                      <input
                        v-model="mobile"
                        class="inp"
                        maxlength="11"
                        :placeholder="$t('business.enterMobile')"
                        type="tel"
                      />
                    </div>
                    <div class="form-item">
                      <input
                        v-model="msgCode"
                        class="inp"
                        :placeholder="$t('accountSettings.security.enterCode')"
                        type="text"
                      />
                      <button @click="getCode">
                        {{
                          second === totalSecond
                            ? $t("accountSettings.security.getCode")
                            : second + "秒后重新发送"
                        }}
                      </button>
                    </div>
                    <button class="login-btn" @click="bindMobile">
                      绑定手机号
                    </button>
                    <div class="tip">
                      <div>提示：</div>
                      <div>新用户请绑定您的手机，保护账号安全。</div>
                    </div>
                  </div>
                </div> -->
              </div>
              <div v-else class="qrcode-invalid">
                <!-- 二维码已失效 -->
                <div>{{ $t('auth.qrExpired') }}</div>
                <!-- 点击刷新 -->
                <button class="refresh-btn" @click="refreshQrcode">
                  {{ $t('auth.refreshQr') }}
                </button>
              </div>
            </div>

            <!-- 免密登录 -->
            <div v-else-if="activeTab === 'sms'" class="sms-login">
              <div class="form">
                <div class="form-item">
                  <!-- 请输入手机号 -->
                  <input
                    v-model="mobile"
                    class="inp"
                    maxlength="11"
                    :placeholder="$t('auth.enterMobile')"
                    type="tel"
                  />
                </div>
                <div class="form-item">
                  <!-- 请输入验证码 -->
                  <input
                    v-model="msgCode"
                    class="inp"
                    inputmode="numeric"
                    maxlength="4"
                    autocomplete="one-time-code"
                    :placeholder="$t('auth.enterCode')"
                    type="text"
                    @input="handleLoginCodeInput"
                  />
                  <!-- 获取验证码 -->
                  <!-- 秒后重新发送 -->
                  <button @click="getCode">
                    {{
                      second === totalSecond
                        ? $t('auth.getCode')
                        : second + $t('devUpdates.secondsBeforeResending')
                    }}
                  </button>
                </div>
                <!-- 登录 -->
                <button class="login-btn" @click="login">
                  {{ $t('common.login') }}
                </button>
              </div>
            </div>
            <!-- 测试 -->
            <!-- <button @click="toggleTimer">
          {{ timerRunning ? $t("auth.close") : "开启" }}
        </button>
        <p>{{ status }}</p> -->
            <!-- 测试 -->
            <!-- <div class="other-login">
              <p>{{ $t("mobileLogin.otherLoginMethods") }}</p>
              <div class="icon-list">
                <span class="icon wechat">{{ $t("common.wechat") }}</span>
                <span class="icon qq">QQ</span>
                <span class="icon weibo">{{ $t("pcFooter.weibo") }}</span>
                <span class="icon taobao">{{ $t("pcFooter.taobao") }}</span>
                <span class="icon alipay">支付宝</span>
              </div>
            </div> -->

            <!-- 底部协议 -->
            <!-- 登录/注册即代表同意 -->
            <!-- 《用户协议》 -->
            <!-- 与 -->
            <!-- 《隐私政策》 -->
            <div class="agreement">
              {{ $t('devUpdates.byLoggingInOrSigningUpYouAgreeTo') }}
              <a href="javascript:;" class="link">{{
                $t('auth.userAgreement')
              }}</a>
              {{ $t('devUpdates.and') }}
              <a href="javascript:;" class="link">{{
                $t('auth.privacyPolicy')
              }}</a>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import devSyncI18n from "@/i18n/common/index";

import {
  getPicCode,
  getMsgCode,
  codeLogin,
  wxLogin,
  getWxmpCode,
  selectWxmpLoginStatus,
  bindMobile,
} from "@/api/login";
import { getBannerAdv, getNavList } from "@/api/home";
import { getUserInfoDetail } from "@/api/user.js";
import { Toast } from "vant";
import { mapState } from "vuex";
import PcFooter from "@/components/pc/PcFooter.vue";

export default {
  mixins: [devSyncI18n],
  components: {
    PcFooter,
  },
  name: "pcPage",
  data() {
    return {
      logoList: [], //logo列表
      navList: [], //上方导航列表（没图片）
      bannerNavList: [], //下方导航列表（有图片）
      picCode: "", //用户输入的图像验证码
      picKey: "", //请求传递的图形验证码唯一标识
      picUrl: "", //存储请求渲染的图片地址
      totalSecond: 60, //总秒数
      second: 60, //当前秒数 开定时器
      time1: null, //定时器id 微信登录二维码
      time2: null, //定时器id 短信验证码
      // mobile: "15818590119", //手机号
      // msgCode: "1234", //短信验证码
      mobile: "",
      msgCode: "",
      isAgree: false, // 协议勾选状态
      dialogVisible: false, // 登录弹窗状态
      wxLoginUrl: "", //pc端微信登录地址
      activeTab: "wechat", // 登录方式，默认微信登录
      status: "", // 扫码状态
      ticket: "", // 扫码票据
      token: "", // 扫码成功后返回的token
      isInvalid: false, // 登录是否失效
      startTime: "", // 登录失效开始时间
      timeoutDuration: 1000 * 60 * 5, // 登录失效时间 5分钟
      searchKeyword: "", // PC 首页搜索词，用来进入全站搜索结果页
    };
  },
  async created() {
    this.queryBannerAdv(
      { which: 1, type: 1, position: "HOME", status: 0 },
      (res) => {
        if (res.code == 200 && res.data && res.data.length > 0) {
          this.logoList = res.data.sort((a, b) => a.sort - b.sort);
        }
      },
    );
    this.queryBannerAdv(
      { which: 1, type: 5, position: "HOME", status: 0 },
      (res) => {
        if (res.code == 200 && res.data && res.data.length > 0) {
          this.bannerNavList = res.data.sort((a, b) => a.sort - b.sort);
        }
      },
    );
    this.getNavList({ which: 1, position: "HOME", status: 0 }, (res) => {
      if (res.code == 200 && res.data && res.data.length > 0) {
        this.navList = res.data.sort((a, b) => a.sort - b.sort);
      }
    });
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userDetails,
    }),
  },
  beforeDestroy() {
    console.log("组件销毁前");
    this.clearPolling(this.time1); // 组件销毁前清除定时器1
    this.clearPolling(this.time2); // 组件销毁前清除定时器2
  },
  methods: {
    onProductSearch() {
      const keyword = (this.searchKeyword || "").trim();
      if (!keyword) return;

      // PC 首页搜索进入全站搜索结果页，保留原搜索关键词。
      this.$router.push({
        path: "/pc/search",
        query: { keyword },
      });
    },
    // 通用导航banner图列表
    queryBannerAdv(params, callback) {
      getBannerAdv(params)
        .then((resp) => {
          callback(resp);
        })
        .catch((error) => {
          console.error("查询banner失败:", error);
        });
    },
    // 通用导航列表
    getNavList(params, callback) {
      getNavList(params)
        .then((resp) => {
          callback(resp);
        })
        .catch((error) => {
          console.error("查询nav失败:", error);
        });
    },
    // 打开pc登录弹窗
    openLoginDialog() {
      this.dialogVisible = true;
      if (this.activeTab === "wechat") {
        this.getWxmpCode();
      } else {
        // this.getPicCode();
      }
    },
    // 关闭弹窗
    handleClose() {
      console.log("关闭弹窗");
      this.dialogVisible = false;
      this.clearPolling(this.time1); // 关闭弹窗时清除定时器1
      this.clearPolling(this.time2); // 关闭弹窗时清除定时器2
    },
    //切换登录方式
    handleClick(tab) {
      this.activeTab = tab.name;
      this.clearPolling(this.time1); //切换登录方式时清除定时器1
      if (tab.name === "wechat") {
        this.getWxmpCode();
      }
      if (tab.name === "sms") {
        this.clearPolling(this.time1); //切换登录方式时清除定时器1
        // this.getPicCode();
      }
    },
    validMobile() {
      if (!/^1[3-9]\d{9}$/.test(this.mobile)) {
        // 请输入正确的手机号
        this.$toast(this.$t("auth.invalidMobile"));
        return false;
      }
      // if (!/^\w{4}$/.test(this.picCode)) {
      //   this.$toast("请输入正确的图形验证码");
      //   return false;
      // }
      return true;
    },
    // 获取短信验证码
    async getCode() {
      if (!this.validMobile()) {
        //如果没通过校验 没必要继续往下走
        return;
      }
      if (!this.time2 && this.second === this.totalSecond) {
        // await getMsgCode(this.picCode, this.picKey, this.mobile);
        await getMsgCode(this.mobile, "+86", "login");
        // 短信已发送,注意查收
        this.$toast(this.$t("realname.smsSent"));
        // 开启定时器
        this.time2 = setInterval(() => {
          this.second--;
          if (this.second <= 0) {
            this.clearPolling(this.time2);
            this.second = this.totalSecond; //重置时间
          }
        }, 1000);
      }
    },
    // 获取图形验证码
    async getPicCode() {
      const {
        data: { base64, key },
      } = await getPicCode();
      this.picUrl = base64; //存储地址
      this.picKey = key; //存储唯一标识

      // this.$toast.success('成功文案')
    },
    //生成uuid
    generateSimpleUUID() {
      return (
        Math.random().toString(36).substring(2, 15) +
        Math.random().toString(36).substring(2, 15)
      );
    },
    // 获取微信扫码登录二维码url
    getWxmpCode() {
      //通过方法获取自己生成的uuid
      const uuid = this.generateSimpleUUID();
      getWxmpCode(uuid)
        .then((res) => {
          if (res.code === 200) {
            const { url, ticket } = JSON.parse(res.msg);
            this.ticket = ticket;
            this.wxLoginUrl = `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${ticket}`;
            this.startTime = Date.now(); //记录登录开始时间
            this.startPolling();
          } else {
            throw new Error(res.msg || "请求异常！");
          }
        })
        .catch((error) => {
          const errorMsg =
            error.response?.data?.msg || error.message || "请求异常！";
          this.$toast(errorMsg);
        });
    },
    //开始轮询
    startPolling() {
      this.time1 = setInterval(() => {
        const now = Date.now();
        const duration = now - this.startTime;
        if (duration >= this.timeoutDuration) {
          this.isInvalide = true;
          this.clearPolling(this.time1); //失效后停止轮训
          return;
        }
        //调取轮询接口
        this.selectWxmpLoginStatus();
      }, 3000);
    },
    // 轮询扫码状态
    async selectWxmpLoginStatus() {
      const uuid = this.generateSimpleUUID();
      const res = await selectWxmpLoginStatus(uuid, this.ticket);
      if (res.code === 200) {
        if (res.data.token) {
          // this.token = res.data.token;
          this.clearPolling(this.time1); // 扫码成功后停止轮训
          this.updateUserInfo(res.data);
        }
      } else {
        // 请求异常！
        Toast(res.msg ? res.msg : this.$t("mobileLogin.requestError"));
      }
    },
    // 清除轮训定时器
    clearPolling(timerId) {
      if (timerId) {
        clearInterval(timerId);
        timerId = null;
      }
    },
    // 刷新二维码
    refreshQrcode() {
      this.isInvalid = false;
      this.getWxmpCode();
    },
    handleLoginCodeInput(event) {
      const code = String(event.target.value || "")
        .replace(/\D/g, "")
        .slice(0, 4);
      event.target.value = code;
      this.msgCode = code;
    },
    // 登录
    async login() {
      if (!this.validMobile()) {
        return;
      }
      // if (!this.isAgree) {
      //   this.$toast("请阅读并同意相关协议");
      //   return;
      // }
      if (!/^\d{4}$/.test(this.msgCode)) {
        // 请输入正确的手机验证码
        this.$toast(this.$t("devUpdates.enterAValidMobileVerificationCode"));
        return;
      }
      const res = await codeLogin(this.mobile, this.msgCode);
      if (res.code == 200) {
        console.log("登录返回", res.data);
        this.updateUserInfo(res.data);
      } else {
        // 请求异常！
        Toast(res.msg ? res.msg : this.$t("mobileLogin.requestError"));
      }
    },
    async updateUserInfo(data) {
      this.$store.commit("user/setUserInfo", data);
      try {
        const response = await getUserInfoDetail();
        if (response.code === 200 && response.data) {
          this.$store.commit(
            "user/setUserDetails",
            response.data.userInfo ?? {},
          );
          this.$message({
            message: "登录成功！",
            type: "success",
          });
          this.dialogVisible = false;
        }
      } catch (error) {
        const errorMsg =
          error.response?.data?.msg || error.message || "请求异常！";
        this.$message({
          message: errorMsg,
          type: "error",
        });
      }
    },
    logout() {
      console.log("退出登录");
      this.$confirm(
        // 你确认要退出登录吗？
        this.$t("devUpdates.areYouSureYouWantToLogOut"),
        // 温馨提示
        this.$t("mobile.product.notice"),
        {
          // 确定
          confirmButtonText: this.$t("auth.confirm"),
          // 取消
          cancelButtonText: this.$t("business.cancel"),
          type: "warning",
        },
      )
        .then(() => {
          // 用户点击确定
          this.$store.dispatch("user/logout");
          if (this.$route.path === "/pc/home" || this.$route.path === "/") {
            window.location.reload();
          } else {
            this.$router.replace("/pc/home");
          }
        })
        .catch(() => {
          // 用户点击取消
          // 已取消退出
          this.$message.info(this.$t("devUpdates.logoutCancelled"));
        });
    },
    // 绑定手机号
    bindMobile() {
      bindMobile(this.mobile, this.msgCode).then((res) => {
        if (res.code === 200) {
          // 绑定成功
          this.$toast(this.$t("devUpdates.linkedSuccessfully"));
          console.log(res.data);
        } else {
          // 请求异常！
          Toast(res.msg ? res.msg : this.$t("mobileLogin.requestError"));
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
}
body {
  background-color: #f8f8f8;
}
a {
  text-decoration: none;
  color: #2a2d2e;
}

.header {
  width: 100%;
  height: var(--custom-xsou-height);
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.nav-container {
  width: 1480px;
  height: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.logo {
  width: 220px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: left;
  color: white;
  font-size: 16px;
}

.nav-links {
  display: flex;
  flex-grow: 1;
}

.nav-link {
  margin-right: 24px;
  font-size: 16px;
  color: #333;
  text-decoration: none;
  // line-height: 62px;
  transition: color 0.3s;
}

.nav-link:hover {
  color: #1890ff;
}

.nav-link:last-child {
  margin-right: 0;
}

.auth-links {
  margin-left: auto;
}

.auth-links a {
  color: #666;
  text-decoration: none;
  font-size: 14px;
  margin-left: 20px;
}

.auth-links a:hover {
  color: #1890ff;
}

.banner {
  width: 100%;
  height: 654px;
  background-image: url("@/assets/pc/pc-bg.png");
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.banner::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 1;
}
.banner-content {
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.banner-logo {
  width: 750px;
  height: 71px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-container {
  width: 1186px;
  height: 43px;
  position: relative;
  margin-top: 35px;
}

.search-input {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 70px;
  padding: 0 140px 0 20px;
  font-size: 16px;
  outline: none;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.search-button {
  position: absolute;
  right: 0;
  top: 0;
  width: 127px;
  height: 43px;
  background-color: #4286f5;
  color: white;
  border: none;
  border-radius: 70px;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s;
}

.search-button:hover {
  background-color: #3367cc;
}

.news-section {
  margin-top: 40px;
  width: 100%;
}

.news-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
}

.news-grid {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.news-item {
  width: 346px;
  height: 336px;
  border: 1px solid #e0e0e0;
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
}

.news-item:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transform: translateY(-5px);
}

.news-image {
  width: 180px;
  height: 180px;
  margin: 20px auto 15px;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.news-image img {
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
}

.news-heading {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin: 0 15px 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.news-desc {
  font-size: 16px;
  text-align: center;
  margin: 0 15px 20px;
  color: #666;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

// .footer {
//   width: 100%;
//   background-color: #f8f8f8;
//   padding: 40px 0 40px;
//   margin-top: 20px;

// .footer-divider {
//   width: 1480px;
//   margin: 0 auto;
//   border-top: 1px solid #a3a3a3;
//   margin-bottom: 40px;
// }

// .footer-content {
//   width: 1480px;
//   margin: 0 auto;
//   display: flex;
//   justify-content: space-between;
// }

// .footer-left {
//   display: flex;
//   flex-direction: column;
// }

// .footer-logo {
//   width: 113px;
//   height: 26px;
//   margin-bottom: 20px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   color: white;
//   font-size: 12px;
// }

// .social-icons {
//   display: flex;
//   gap: 15px;
//   margin-bottom: 20px;
// }

// .social-icon {
//   width: 28px;
//   height: 28px;
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// }

// .copyright {
//   font-size: 14px;
//   color: #666;
//   margin-bottom: 8px;
// }

// .icp {
//   font-size: 14px;
//   color: #666;
// }
// .icp a {
//   font-size: 14px;
//   color: #666;
//   text-decoration: none;
// }

// .footer-right {
//   display: flex;
//   gap: 60px;
// }

// .footer-column {
//   display: flex;
//   flex-direction: column;
// }

// .column-title {
//   font-size: 16px;
//   font-weight: bold;
//   margin-bottom: 15px;
//   color: #333;
// }

// .column-link {
//   font-size: 16px;
//   color: #666;
//   margin-bottom: 12px;
//   text-decoration: none;
//   transition: color 0.3s;
// }

// .column-link:hover {
//   color: #1890ff;
// }

// .column-link:last-child {
//   margin-bottom: 0;
// }
// }

// elelui
/* 弹窗整体样式 */
.login-dialog {
  overflow: hidden;
}

/* 内容容器 */
.dialog-content {
  display: flex;
  background-color: white;
}

.left-poster img {
  width: 350px;
  height: 540px; //容器高度是500px，还有40px的顶部header，所以高度是540px
  margin-top: -40px; //顶部header的高度是40px，所以margin-top是-40px
}

/* 右侧面板 */
.right-panel {
  flex: 1;
  // padding: 20px;
}

/* 标签栏 */
// .tab-header {
//   display: flex;
//   border-bottom: 1px solid #e6e6e6;
// }

// .tab-item {
//   flex: 1;
//   text-align: center;
//   padding: 10px 0;
//   cursor: pointer;
//   color: #666;
// }

// .tab-item.active {
//   color: #409eff;
//   border-bottom: 2px solid #409eff;
// }
.form {
  width: 310px;
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .form-item {
    width: 100%;
    height: 52px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    background: #fff;
    border: 1px solid #eee;
    margin-bottom: 16px;
    box-shadow: 0px 4px 6px 0px rgba(219, 223, 229, 0.3);
    .inp {
      flex: 1;
      height: 40px;
      line-height: 40px;
      border: none;
      outline: none;
      padding: 0 10px;
      font-size: 14px;
      color: #333;
    }
    button {
      height: 36px;
      line-height: 36px;
      border: none;
      background-color: transparent;
      color: #1989fa;
      padding: 0 10px;
      font-size: 14px;
    }
  }
  .unregister-tip {
    text-align: left;
    width: 100%;
    font-size: 14px;
    color: #999;
    margin-bottom: 10px;
  }
  .register {
    color: #1989fa;
  }
  .login-btn {
    width: 100%;
    height: 52px;
    line-height: 52px;
    text-align: center;
    background: linear-gradient(90deg, #1989fa, #4286f5);
    color: #fff;
    border-radius: 12px;
    border: none;
    font-size: 16px;
    margin-bottom: 12px;
  }
  .tip {
    text-align: left;
  }
  .third-party {
    text-align: center;
    padding-top: 40px;
    width: 100%;
    .third-party-text {
      font-size: 12px;
    }
    .wechat-icon {
      font-size: 42px;
      color: #09bb07;
    }
  }
}

/* 标签内容 */
.tab-content {
  padding: 20px 0;
}

.wechat-login {
  text-align: center;
}

.qrcode {
  margin: 20px auto;
  width: 200px;
  height: 200px;
  background-color: #f5f5f5;
}
.qrcode-invalid {
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  gap: 30px;
  text-align: center;
  font-size: 20px;
  padding-top: 40px;
}

.refresh-btn {
  width: 200px;
  height: 40px;
  margin: 0 auto;
  line-height: 40px;
  text-align: center;
  border-radius: 12px;
  border: none;
  font-size: 14px;
  margin-bottom: 20px;
}

.other-login {
  text-align: center;
}

.other-login p {
  margin-bottom: 10px;
  color: #999;
}

.icon-list {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.icon {
  display: inline-block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
}

.wechat {
  background-color: #4caf50;
}
.qq {
  background-color: #12b7f5;
}
.weibo {
  background-color: #ff764b;
}
.taobao {
  background-color: #ff6700;
}
.alipay {
  background-color: #2088ff;
}

/* 协议 */
.agreement {
  text-align: center;
  color: #999;
  font-size: 12px;
  margin-top: 20px;
}

.link {
  color: #409eff;
  cursor: pointer;
}
// elelui
</style>
